/**
 * 系统自定义配置
 */

const customization = {
    crmUrl:"http://192.168.7.99:3652/crmstddev",
    copyright:"Copyright © 2014 得力集团有限公司 上海得力文具有限公司 All Rights Reserved",
    themeColor:""
};

export const copyright = customization.copyright;
export const themeColor = customization.themeColor;
export const crmUrl = customization.crmUrl;

export default customization;


// WEBPACK FOOTER //
// ./src/config/customization.js